var _circle, _path;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgProfileFill = function SvgProfileFill(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 99.5",
    style: {
      enableBackground: "new 0 0 100 99.5"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.1,
    cy: 39.5,
    r: 16.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50,0.3C22.7,0.3,0.4,22.5,0.4,49.9S22.7,99.5,50,99.5s49.6-22.3,49.6-49.6S77.3,0.3,50,0.3z M79.2,81.2 C75.5,71.5,67.6,61.1,50,61.1c-17.5,0-25.5,10.4-29.2,20.2c-8.4-7.8-13.7-19-13.7-31.3C7.1,26.3,26.3,7,50,7s42.9,19.2,42.9,42.9 C92.9,62.2,87.5,73.4,79.2,81.2z"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProfileFill, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/profile-fill.1146f5aa.svg";
export { ForwardRef as ReactComponent };